'use client';

import { AspectRatioProps, Box, BoxProps, Image, Skeleton } from '@chakra-ui/react'
import NextImage, { ImageProps } from 'next/image'

import { useState } from 'react'

type NextImageWithSkeletonProps = {
	src: string
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
  sizes?: string
  width?: string
  height?: string
  aspectRatio?: BoxProps['aspectRatio']
  borderRadius?: BoxProps['borderRadius']
} & Omit<ImageProps, 'src' | 'height' | 'width'>

export const NextImageWithSkeleton = ({ 
  src,
  objectFit = 'cover',
  sizes,
  width,
  height,
  aspectRatio,
  borderRadius,
  loading = 'lazy',
  ...imageProps
}: NextImageWithSkeletonProps) => {
	const [isLoading, setIsLoading] = useState(true)

	return (
		<Box 
      width={width} 
      aspectRatio={aspectRatio}
      height={height} 
      borderRadius={borderRadius}
      overflow={'hidden'}
    >
			<Skeleton
        variant={'shine'}
				width={width} 
        height={height} 
				aspectRatio={aspectRatio}
				loading={isLoading}
        pos={'relative'}
			>
				<Image asChild>
					<NextImage
						fill
						src={src}
						onLoad={() => setIsLoading(false)}
						loading={loading}
						priority={false}
						style={{  objectFit }}
            sizes={sizes}
            {...imageProps}
					/>
				</Image>
			</Skeleton>
		</Box>
	)
}
